// extracted by mini-css-extract-plugin
module.exports = {"repeatHolder":"AudioRepeat_repeatHolder__1JLR1","repeatAudio":"AudioRepeat_repeatAudio__22Joy"};